import Axios from 'axios';
import i18n from 'i18next';
import { toast } from 'react-toastify';

import type { StreamName } from '@vlabs/api/luna-api/model';

export interface GulfstreamConfig {
  url: string;
  token: string;
  object_id: string;
  object_name: string;
  address: string;
  lat: string;
  lng: string;
  inn: string;
  partner_name: string;
  alarm_type: string;
}

export interface GulfstreamAlarmHandlerProps {
  eventType: string;
  streamName: StreamName;
  gulfstreamConfig: GulfstreamConfig;
}

export const isValidGulfstreamConfig = (
  gulfstreamConfig: Partial<GulfstreamConfig> | null | undefined,
): boolean => {
  const isGulfstreamConfigValid = gulfstreamConfig?.url
    && gulfstreamConfig.token
    && gulfstreamConfig.object_id
    && gulfstreamConfig.object_name
    && gulfstreamConfig.address
    && gulfstreamConfig.lat
    && gulfstreamConfig.lng
    && gulfstreamConfig.inn
    && gulfstreamConfig.partner_name
    && gulfstreamConfig.alarm_type;

  return Boolean(isGulfstreamConfigValid);
};

export async function sendGulfstreamAlarm({
  eventType,
  streamName,
  gulfstreamConfig,
}: GulfstreamAlarmHandlerProps): Promise<void> {
  const { url, token, ...parameters } = gulfstreamConfig;

  const remark = `${i18n.t(`features:alarm_button.event_type.${eventType}`)} / ${streamName}`;

  await Axios.post(`${url}?command=alarm`, { remark, ...parameters }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  toast.success(i18n.t('features:alarm_button.success'));
}
